import { Text, View } from '@react-pdf/renderer'

import { styles } from '../styles/styles'
import { ResolutionIcon } from './ResolutionIcon'
import { TimelineIcon } from './TimelineIcon'
import { WorkflowIcon } from './WorkflowIcon'

type SectionIcon = 'resolution' | 'timeline' | 'workflow'

interface SectionTitleIProps {
  icon: SectionIcon
  title: string
}

const Icon = ({ icon }: { icon: SectionIcon }) => {
  switch (icon) {
    case 'resolution':
      return <ResolutionIcon />
    case 'timeline':
      return <TimelineIcon />
    case 'workflow':
      return <WorkflowIcon />
  }
}

export const SectionTitle = ({ icon, title }: SectionTitleIProps) => (
  <View style={styles.sectionTitle}>
    <Icon icon={icon} />
    <Text style={styles.sectionTitleText}>{title}</Text>
  </View>
)
